export enum Colors {
  background = '#F9F8F7',
  dark = '#54575A',
  grey = "#6E7272",
  light = "darkgrey"
}

export enum Breakpoints {
  xSmall = 480,
  Small = 800,
  Medium = 992,
  Large = 1200,
}
